"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const customMonthHeader = (arg) => {
    const headerCell = ({ children }) => {
        return ((0, jsx_runtime_1.jsxs)("a", Object.assign({ style: { textAlign: 'center' } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ style: { textAlign: 'center', display: 'block' } }, { children: arg.month })), children] })));
    };
    return headerCell;
};
exports.default = customMonthHeader;
